var render, staticRenderFns
import script from "./ordnerTree.vue?vue&type=script&lang=js&"
export * from "./ordnerTree.vue?vue&type=script&lang=js&"
import style0 from "./ordnerTree.vue?vue&type=style&index=0&id=4dd4a98a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4a98a",
  null
  
)

export default component.exports